import { useMemo, Fragment } from 'react';
import { useLocation, NavLink } from 'react-router-dom';
import styled from 'styled-components';
import './Breadcrumbs.scss';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Chevron = styled.i`
  margin: 0 5px;
  font-size: 7px;
`;

const Breadcrumbs = () => {
  const location = useLocation();
  const { pathname } = location;

  const breadcrumbs = useMemo(() => {
    const links = [{ path: '/', label: 'Dashboard' }];
    const isVerifySourcesPage = pathname.startsWith('/verify-sources');
    if (pathname === '/crawler-config') {
      links.push({ path: '/crawler-config', label: 'Crawler Config' });
    }
    if (pathname === '/entity-listing' || isVerifySourcesPage) {
      links.push({ path: '/entity-listing', label: 'Verify URLs' });
    }
    if (isVerifySourcesPage) {
      links.push({ path: pathname, label: 'Verify Sources' });
    }
    return links;
  }, [pathname]);

  return (
    <Wrapper>
      {breadcrumbs.map((breadcrumb, index) => (
        <Fragment key={breadcrumb.path}>
          <NavLink
            className="bc"
            activeClassName="bc--active"
            to={breadcrumb.path}
            aria-current="page"
            exact
          >
            {breadcrumb.label}
          </NavLink>
          {index < breadcrumbs.length - 1 && <Chevron className="icon-Right" />}
        </Fragment>
      ))}
    </Wrapper>
  );
};

export default Breadcrumbs;
